// extracted by mini-css-extract-plugin
export default {"wrapper":"error-btn-box_wrapper__oNXXn","boxError":"error-btn-box_boxError__0visb"};